export enum CreativeType {
  Banner = 'banner',
  Outstream = 'outstream',
  Native = 'native'
}
